"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.setUsesLightStatusBarBackgroundColor = exports.takeDocumentFromGallery = exports.takePictureFromGallery = exports.takePictureWithCamera = exports.resetApp = exports.logOutWithConfirmation = exports.logOut = exports.setPushSettingsForChannel = exports.getPushSettings = exports.postCurrentEmsId = exports.postLogEntry = exports.changePassword = exports.registerUser = exports.waitForPinRequest = exports.resetPassword = exports.revalidateUser = exports.createPassword = exports.checkActivationCode = exports.updateActivatedFeaturesInStore = exports.isActivated = exports.getUser = exports.getCachePath = exports.updateContent = exports.getXml = exports.getHomeCourseId = exports.getPromise = exports.PLUGIN_CAMERA = exports.PLUGIN_NETWORK_MANAGER = exports.PLUGIN_DEVICE_INFO = exports.PLUGIN_DATA_OBJECTS = exports.PLUGIN_FEATURE_MANAGER = exports.PLUGIN_EQUIZZER = exports.PLUGIN_ERGO_QUIZ = exports.PLUGIN_GENERAL_TASKS = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _mock_prod = _interopRequireDefault(require("../../mock/mock_prod.js"));

var _EquizzerActions = _interopRequireDefault(require("../../src/common/components/Equizzer/actions/EquizzerActions"));

var _LogService = require("../KESI2/Services/LogService");

var _CordovaFileHelper = _interopRequireWildcard(require("./CordovaFileHelper"));

var _AlertHelper = require("./AlertHelper");

var _NavigationManager = _interopRequireDefault(require("../common/NavigationManager"));

var _FeatureManager = _interopRequireDefault(require("../utils/features/FeatureManager"));

var _RestService = _interopRequireDefault(require("../common/components/Equizzer/services/RestService"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _ThemeStore = _interopRequireDefault(require("../common/components/ThemeStore/ThemeStore2"));

var _TimeoutHelper = require("./TimeoutHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("./DeviceInfoHelper"));

var _BuildConstants = require("../utils/BuildConstants");

var _MuiAlertHelper = require("./MuiAlertHelper");

var _strings = require("../../config/strings");

var _MessagingService = _interopRequireDefault(require("../KESI2/Services/MessagingService"));

var _RegisterInstance = _interopRequireDefault(require("../KESI2/Services/RegisterInstance"));

var _config = _interopRequireDefault(require("../../targets/cord_eurofh_teams/config.js"));

var _DeviceTracking = _interopRequireDefault(require("../tracking/DeviceTracking"));

var _mobx = require("mobx");

/*
 * Use this helper to communicate with native cordova plugins.
 */
// noinspection Eslint
// eslint-disable-line
var PLUGIN_GENERAL_TASKS = 'GeneralTasksPlugin';
exports.PLUGIN_GENERAL_TASKS = PLUGIN_GENERAL_TASKS;
var PLUGIN_ERGO_QUIZ = 'ErgoQuizPlugin';
exports.PLUGIN_ERGO_QUIZ = PLUGIN_ERGO_QUIZ;
var PLUGIN_EQUIZZER = 'EquizzerPlugin';
exports.PLUGIN_EQUIZZER = PLUGIN_EQUIZZER;
var PLUGIN_FEATURE_MANAGER = 'FeatureManagerPlugin';
exports.PLUGIN_FEATURE_MANAGER = PLUGIN_FEATURE_MANAGER;
var PLUGIN_DATA_OBJECTS = 'DataObjectsPlugin';
exports.PLUGIN_DATA_OBJECTS = PLUGIN_DATA_OBJECTS;
var PLUGIN_DEVICE_INFO = 'DeviceInfoPlugin';
exports.PLUGIN_DEVICE_INFO = PLUGIN_DEVICE_INFO;
var PLUGIN_NETWORK_MANAGER = 'NetworkManagerPlugin';
exports.PLUGIN_NETWORK_MANAGER = PLUGIN_NETWORK_MANAGER;
var PLUGIN_CAMERA = 'CameraPlugin';
exports.PLUGIN_CAMERA = PLUGIN_CAMERA;

function outputResponseResponse(pluginName, methodName, args, response, callback) {
  // console.log(`Success for ${pluginName} / ${methodName} / ${JSON.stringify(args[0])}: ${response}`);
  console.log("Success for ".concat(pluginName, " / ").concat(methodName));
  callback(response);
}

function outputResponseReject(pluginName, methodName, args, reject, callback) {
  // console.log(`Reject for ${pluginName} / ${methodName} / ${JSON.stringify(args[0])}: ${reject}`);
  console.log("Reject for ".concat(pluginName, " / ").concat(methodName));
  callback(reject);
}
/**
 * args must be an array of Objects. Otherwise the promise will fail.
 *
 * @param pluginName
 * @param methodName
 * @param args array of Objects. Otherwise the promise will fail.
 * @returns {Promise}
 */


var getPromise = function getPromise(pluginName, methodName) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (process.env.IS_RAHMENAPP === false || process.env.IS_RAHMENAPP === 'false') {
    return _promise["default"].reject(new Error('Not living in a rahmenapp world, all cordova requests will be denied'));
  } // eslint-disable-next-line promise/avoid-new


  return new _promise["default"](function (resolve, reject) {
    console.log("calling ".concat(pluginName, " / ").concat(methodName, " / ").concat((0, _stringify["default"])(args[0])));

    if (window.cordova && window.cordova.exec) {
      window.cordova.exec(function (response) {
        return outputResponseResponse(pluginName, methodName, args, response, resolve);
      }, function (error) {
        return outputResponseReject(pluginName, methodName, args, error, reject);
      }, pluginName, methodName, args);
    } else if (_BuildConstants.NODE_ENV !== 'production') {
      (0, _mock_prod["default"])(function (response) {
        return outputResponseResponse(pluginName, methodName, args, response, resolve);
      }, function (error) {
        return outputResponseReject(pluginName, methodName, args, error, reject);
      }, pluginName, methodName, args);
    } else {
      var message = 'not calling because window.cordova undefined and not running in dev mode';
      console.log(message);
      reject(message);
    }
  });
};

exports.getPromise = getPromise;

var getHomeCourseId = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", getPromise(PLUGIN_GENERAL_TASKS, 'getHomeCourseId', []));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getHomeCourseId() {
    return _ref.apply(this, arguments);
  };
}();

exports.getHomeCourseId = getHomeCourseId;

var getXml = function getXml(emsId) {
  return getPromise(PLUGIN_GENERAL_TASKS, 'getXml', [{
    emsId: emsId
  }]);
};

exports.getXml = getXml;

var updateContent = function updateContent() {
  return getPromise(PLUGIN_GENERAL_TASKS, 'updateContent');
};

exports.updateContent = updateContent;
var cachePaths = {};

var getCachePath = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(emsId) {
    var cachePath;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!cachePaths[emsId]) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", _promise["default"].resolve(cachePaths[emsId]));

          case 2:
            _context2.prev = 2;
            _context2.next = 5;
            return _CordovaFileHelper["default"].getFolderEntry(_CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

          case 5:
            cachePath = _context2.sent.nativeURL;

            // await getPromise(PLUGIN_GENERAL_TASKS, 'getCachePath', [{emsId}])
            if (!cachePath.endsWith('/')) {
              cachePath += '/';
            }

            cachePaths[emsId] = cachePath;
            return _context2.abrupt("return", _promise["default"].resolve(cachePath));

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", _promise["default"].reject(_context2.t0));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 11]]);
  }));

  return function getCachePath(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getCachePath = getCachePath;

var getUser = function getUser(feature) {
  if (feature === 'ergoquiz') {
    return getPromise(PLUGIN_ERGO_QUIZ, 'getUser', [feature]);
  } else if (feature === 'equeoqd') {
    return getPromise(PLUGIN_EQUIZZER, 'getUser', [feature]);
  }

  return getPromise(PLUGIN_FEATURE_MANAGER, 'getUser', [{
    featureName: feature
  }]);
};

exports.getUser = getUser;

var isActivated = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(featureName) {
    var user;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return getUser(featureName);

          case 3:
            user = _context3.sent;
            return _context3.abrupt("return", _promise["default"].resolve(user != null && (user.activated === true || user.activated === 'true')));

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", _promise["default"].resolve(false));

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function isActivated(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

exports.isActivated = isActivated;

var updateActivatedFeaturesInStore = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, activatedFeatures;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return getPromise(PLUGIN_FEATURE_MANAGER, 'getAllFeatures');

          case 2:
            response = _context4.sent;
            console.log('updateActivatedFeaturesInStore', response);
            activatedFeatures = [];
            (0, _keys["default"])(response).forEach(function (feature) {
              if (response[feature].activated) {
                activatedFeatures.push(feature);
              }
            });
            console.log({
              activatedFeatures: activatedFeatures
            });

            _EquizzerActions["default"].setActivatedFeatures(activatedFeatures);

            return _context4.abrupt("return", _promise["default"].resolve());

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function updateActivatedFeaturesInStore() {
    return _ref4.apply(this, arguments);
  };
}();

exports.updateActivatedFeaturesInStore = updateActivatedFeaturesInStore;

var checkActivationCode = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(activationCode) {
    var nickName,
        result,
        _args5 = arguments;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            nickName = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : '';
            _context5.next = 3;
            return getPromise(PLUGIN_FEATURE_MANAGER, 'checkActivationCode', [{
              activationCode: activationCode,
              nickName: nickName
            }]);

          case 3:
            result = _context5.sent;
            return _context5.abrupt("return", _promise["default"].resolve(result));

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function checkActivationCode(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

exports.checkActivationCode = checkActivationCode;

var createPassword = function createPassword(user, password) {
  return getPromise(PLUGIN_FEATURE_MANAGER, 'createPassword', [user, password]);
};

exports.createPassword = createPassword;

var revalidateUser = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(code, userName, password, featureName) {
    var result;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(featureName === 'ergoquiz' || featureName === 'equeoqd')) {
              _context6.next = 7;
              break;
            }

            _context6.next = 3;
            return getPromise(PLUGIN_FEATURE_MANAGER, 'revalidateUser', [{
              code: code,
              userName: userName,
              password: password,
              featureName: featureName
            }]);

          case 3:
            result = _context6.sent;
            _context6.next = 6;
            return updateActivatedFeaturesInStore();

          case 6:
            return _context6.abrupt("return", _promise["default"].resolve(result));

          case 7:
            return _context6.abrupt("return", _promise["default"].reject(new Error("cannot register feature ".concat(featureName))));

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function revalidateUser(_x4, _x5, _x6, _x7) {
    return _ref6.apply(this, arguments);
  };
}();

exports.revalidateUser = revalidateUser;

var resetPassword = function resetPassword(featureName) {
  return getPromise(PLUGIN_FEATURE_MANAGER, 'sendResetPinRequestForFeature', [featureName]);
};

exports.resetPassword = resetPassword;

var waitForPinRequest = function waitForPinRequest(featureName) {
  return getPromise(PLUGIN_FEATURE_MANAGER, 'waitForPinRequest', [featureName]);
};

exports.waitForPinRequest = waitForPinRequest;

var registerUser = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(code, password, agreed, featureName, nickName
  /* ignored by server */
  ) {
    var firstName,
        lastName,
        result,
        _args7 = arguments;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            firstName = _args7.length > 5 && _args7[5] !== undefined ? _args7[5] : 'firstname';
            lastName = _args7.length > 6 && _args7[6] !== undefined ? _args7[6] : 'lastname';

            if (!(featureName === 'ergoquiz')) {
              _context7.next = 8;
              break;
            }

            _context7.next = 5;
            return getPromise(PLUGIN_FEATURE_MANAGER, 'registerQuizUser', [{
              code: code,
              firstName: firstName,
              lastName: lastName,
              password: password,
              agreed: agreed
            }]);

          case 5:
            result = _context7.sent;
            _context7.next = 15;
            break;

          case 8:
            if (!(featureName === 'equeoqd')) {
              _context7.next = 14;
              break;
            }

            _context7.next = 11;
            return getPromise(PLUGIN_FEATURE_MANAGER, 'registerEquizzerUser', [{
              code: code,
              firstName: firstName,
              lastName: lastName,
              password: password,
              agreed: agreed,
              nickName: nickName
            }]);

          case 11:
            result = _context7.sent;
            _context7.next = 15;
            break;

          case 14:
            return _context7.abrupt("return", _promise["default"].reject(new Error("cannot register feature ".concat(featureName))));

          case 15:
            _context7.next = 17;
            return updateActivatedFeaturesInStore();

          case 17:
            return _context7.abrupt("return", _promise["default"].resolve(result));

          case 18:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function registerUser(_x8, _x9, _x10, _x11, _x12) {
    return _ref7.apply(this, arguments);
  };
}();

exports.registerUser = registerUser;

var changePassword = function changePassword(user, code, password, featureName
/* ignored by server */
) {
  var firstName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'firstname';
  var lastName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'lastname';

  if (featureName === 'ergoquiz') {
    return getPromise(PLUGIN_FEATURE_MANAGER, 'updateQuizUser', [{
      user: user,
      code: code,
      featureName: featureName,
      firstName: firstName,
      lastName: lastName,
      password: password
    }]);
  }

  return _promise["default"].reject(new Error("cannot register feature ".concat(featureName)));
};

exports.changePassword = changePassword;

var postLogEntry = function postLogEntry(context, type, message) {
  var resultMessage = {
    context: context,
    type: type,
    message: message
  };
  (0, _LogService.pushGenericLogMessage)(resultMessage); // return getPromise(PLUGIN_DATA_OBJECTS, 'postLogEntry', [
  //   {
  //     context: context,
  //     message: JSON.stringify(message)
  //   }
  // ])
};

exports.postLogEntry = postLogEntry;

var postCurrentEmsId = function postCurrentEmsId(context, emsId) {
  return getPromise(PLUGIN_DATA_OBJECTS, 'postCurrentEmsId', [{
    context: context,
    message: emsId
  }]);
};

exports.postCurrentEmsId = postCurrentEmsId;

var getPushSettings = function getPushSettings() {
  return getPromise(PLUGIN_GENERAL_TASKS, 'getPushSettings');
};

exports.getPushSettings = getPushSettings;

var setPushSettingsForChannel = function setPushSettingsForChannel(channelId, channelOn) {
  return getPromise(PLUGIN_GENERAL_TASKS, 'setPushSettingForChannel', [{
    channelId: channelId,
    channelOn: (0, _stringify["default"])(channelOn)
  }]);
};

exports.setPushSettingsForChannel = setPushSettingsForChannel;

var setDefaultDataStoreValues = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    var data;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(_config["default"].defaultDataStoreValues || _config["default"].dataStoreValues)) {
              _context8.next = 6;
              break;
            }

            data = {};

            if (_config["default"].dataStoreValues) {
              (0, _keys["default"])(_config["default"].dataStoreValues).forEach(function (key) {
                data[key] = _config["default"].dataStoreValues[key];
              });
            }

            if (_config["default"].defaultDataStoreValues) {
              (0, _keys["default"])(_config["default"].defaultDataStoreValues).forEach(function (key) {
                if (!_DataStore["default"].pathExists(key)) {
                  data[key] = _config["default"].defaultDataStoreValues[key];
                }
              });
            }

            _context8.next = 6;
            return _DataStore["default"].mergeAndSetData(data);

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function setDefaultDataStoreValues() {
    return _ref8.apply(this, arguments);
  };
}();

var logOut = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
    var goHome,
        setDefaultDataStoreValuesFn,
        removeParams,
        caller,
        urlParts,
        _args9 = arguments;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            goHome = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : true;
            setDefaultDataStoreValuesFn = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : null;
            removeParams = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : false;
            caller = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : 'undefined';
            (0, _LogService.pushTravelAndCareLogMessage)('logOut', {
              goHome: goHome,
              caller: caller
            });

            if (!_DeviceInfoHelper["default"].isBrowser()) {
              _context9.next = 19;
              break;
            }

            window.localStorage.clear();
            _context9.next = 9;
            return _DataStore["default"].resetStore();

          case 9:
            if (!setDefaultDataStoreValuesFn) {
              _context9.next = 12;
              break;
            }

            _context9.next = 12;
            return setDefaultDataStoreValuesFn();

          case 12:
            if (!goHome) {
              _context9.next = 17;
              break;
            }

            _context9.next = 15;
            return (0, _TimeoutHelper.timeout)(1000);

          case 15:
            urlParts = removeParams && window.location.href.indexOf('?') !== -1 ? window.location.href.split('?') : window.location.href.split('#');
            window.location.href = urlParts[0]; // window.location.reload()

          case 17:
            _context9.next = 39;
            break;

          case 19:
            _context9.next = 21;
            return _MessagingService["default"].clear();

          case 21:
            _context9.next = 23;
            return _DataStore["default"].resetStore();

          case 23:
            if (!setDefaultDataStoreValuesFn) {
              _context9.next = 28;
              break;
            }

            _context9.next = 26;
            return setDefaultDataStoreValuesFn();

          case 26:
            _context9.next = 30;
            break;

          case 28:
            _context9.next = 30;
            return setDefaultDataStoreValues();

          case 30:
            _context9.next = 32;
            return _MessagingService["default"].init();

          case 32:
            if (!_config["default"].collectTrackingInformation) {
              _context9.next = 35;
              break;
            }

            _context9.next = 35;
            return _DeviceTracking["default"].trackNow();

          case 35:
            if (!goHome) {
              _context9.next = 39;
              break;
            }

            _context9.next = 38;
            return (0, _TimeoutHelper.timeout)(1000);

          case 38:
            _NavigationManager["default"].goHome(true);

          case 39:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function logOut() {
    return _ref9.apply(this, arguments);
  };
}();

exports.logOut = logOut;

var logOutWithConfirmation = /*#__PURE__*/function () {
  var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
    var goHome,
        cancelButton,
        okButton,
        _args10 = arguments;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            goHome = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : true;
            cancelButton = {
              label: (0, _strings.getString)('CANCEL')
            };
            okButton = {
              label: (0, _strings.getString)('RESET_APP_BUTTON_TEXT'),
              callback: function callback() {
                return logOut(goHome, null, false, 'CordovaHelper logOutWithConfirmation');
              }
            };
            (0, _MuiAlertHelper.showAlert)((0, _strings.getString)('RESET_APP_INFO_TEXT_LINE1') + '\n' + (0, _strings.getString)('RESET_APP_INFO_TEXT_LINE2'), (0, _strings.getString)('RESET_APP_TITLE'), true, [cancelButton, okButton]);

          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function logOutWithConfirmation() {
    return _ref10.apply(this, arguments);
  };
}();

exports.logOutWithConfirmation = logOutWithConfirmation;

var resetApp = /*#__PURE__*/function () {
  var _ref11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
    var sendRequest,
        caller,
        _args12 = arguments;
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            sendRequest = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : true;
            caller = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : 'undefined';
            console.log('logging out');
            (0, _LogService.pushTravelAndCareLogMessage)('resetApp', {
              sendRequest: sendRequest,
              caller: caller
            });
            _context12.prev = 4;

            _FeatureManager["default"].getAllFeatureNames().forEach( /*#__PURE__*/function () {
              var _ref12 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(featureName) {
                var feature, userAuth;
                return _regenerator["default"].wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        feature = _FeatureManager["default"].getFeature(featureName);

                        if (!_config["default"].useDrupalContent) {
                          _context11.next = 9;
                          break;
                        }

                        _context11.t1 = "Bearer ";
                        _context11.next = 5;
                        return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

                      case 5:
                        _context11.t2 = _context11.sent;
                        _context11.t0 = _context11.t1.concat.call(_context11.t1, _context11.t2);
                        _context11.next = 10;
                        break;

                      case 9:
                        _context11.t0 = feature && feature.additionalData && feature.additionalData._auth ? feature.additionalData._auth : null;

                      case 10:
                        userAuth = _context11.t0;

                        if (userAuth) {
                          console.log('sending reset request', feature);

                          if (sendRequest && !_config["default"].useDrupalContent) {
                            _RestService["default"].postReset({
                              action: 'reset',
                              userid: [feature.userId]
                            }, userAuth);
                          }
                        }

                      case 12:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee11);
              }));

              return function (_x13) {
                return _ref12.apply(this, arguments);
              };
            }());

            console.log('resetting all ably channels');
            _context12.next = 9;
            return _MessagingService["default"].clear();

          case 9:
            console.log('resetting feature manager');

            _FeatureManager["default"].clearCache();

            console.log('resetting data store');
            _context12.next = 14;
            return _DataStore["default"].resetStore();

          case 14:
            console.log('resetting equizzer store'); // await DataStore.deleteStore()

            console.log('resetting theme store');
            _context12.next = 18;
            return _ThemeStore["default"].resetTheme();

          case 18:
            _context12.next = 24;
            break;

          case 20:
            _context12.prev = 20;
            _context12.t0 = _context12["catch"](4);
            console.log('error logging out:', _context12.t0);
            setTimeout(function () {
              (0, _AlertHelper.showWideAlertHtml)(_context12.t0, 'Fehler');
            }, 0);

          case 24:
            _context12.next = 26;
            return (0, _TimeoutHelper.timeout)();

          case 26:
            _NavigationManager["default"].goHome(true); // try {
            //   FeatureManager.getAllFeatureNames().forEach(featureName => {
            //     const feature = FeatureManager.getFeature(featureName)
            //     if (feature && feature.userId && feature.additionalData && feature.additionalData._auth) {
            //       console.log('sending reset request', feature)
            //       RestService.postReset({action: 'reset', userid: [feature.userId]}, feature.additionalData._auth)
            //     }
            //     else {
            //       console.log('sending reset request', feature)
            //     }
            //   })
            //
            //   await DataStore.resetStore()
            //   await ThemeStore.resetTheme()
            //   await CordovaFileHelper.deleteDirectory(LOCAL_FILENAMES.DATA_FOLDER)
            // }
            // catch (error) {
            //   console.log(error)
            //   setTimeout(() => {
            //     showWideAlertHtml(error, 'Fehler')
            //   }, 0)
            // }
            //
            // await timeout(1000)
            // NavigationManager.goHome(true)


          case 27:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[4, 20]]);
  }));

  return function resetApp() {
    return _ref11.apply(this, arguments);
  };
}();

exports.resetApp = resetApp;

var takePictureWithCamera = /*#__PURE__*/function () {
  var _ref13 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
    var width,
        height,
        direction,
        allowEdit,
        getAsBase64,
        _args13 = arguments;
    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            width = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : 250;
            height = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : 250;
            direction = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : window.Camera.Direction.FRONT;
            allowEdit = _args13.length > 3 && _args13[3] !== undefined ? _args13[3] : true;
            getAsBase64 = _args13.length > 4 && _args13[4] !== undefined ? _args13[4] : true;
            return _context13.abrupt("return", new _promise["default"](function (resolve, reject) {
              var options = {
                sourceType: window.Camera.PictureSourceType.CAMERA,
                cameraDirection: direction,
                // not working on android if user switched the camera before
                allowEdit: _DeviceInfoHelper["default"].isAndroid ? false : allowEdit,
                // marked as unsafe for Android in the docs but seems to work
                destinationType: getAsBase64 ? window.Camera.DestinationType.DATA_URL : window.Camera.DestinationType.FILE_URI,
                // or FILE_URI
                encodingType: window.Camera.EncodingType.JPEG,
                correctOrientation: true
              };

              if (width) {
                options.targetWidth = width;
              }

              if (height) {
                options.targetHeight = height;
              }

              window.navigator.camera.getPicture(resolve, reject, options);
            }));

          case 6:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function takePictureWithCamera() {
    return _ref13.apply(this, arguments);
  };
}();

exports.takePictureWithCamera = takePictureWithCamera;

var takePictureFromGallery = /*#__PURE__*/function () {
  var _ref14 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
    var width,
        height,
        allowEdit,
        getAsBase64,
        _args14 = arguments;
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            width = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : 250;
            height = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : 250;
            allowEdit = _args14.length > 2 && _args14[2] !== undefined ? _args14[2] : true;
            getAsBase64 = _args14.length > 3 && _args14[3] !== undefined ? _args14[3] : true;
            return _context14.abrupt("return", new _promise["default"](function (resolve, reject) {
              var options = {
                sourceType: window.Camera.PictureSourceType.PHOTOLIBRARY,
                allowEdit: _DeviceInfoHelper["default"].isAndroid ? false : allowEdit,
                // marked as unsafe for Android in the docs but seems to work
                destinationType: getAsBase64 ? window.Camera.DestinationType.DATA_URL : window.Camera.DestinationType.FILE_URI,
                // or FILE_URI
                correctOrientation: true
              };

              if (width) {
                options.targetWidth = width;
              }

              if (height) {
                options.targetHeight = height;
              }

              window.navigator.camera.getPicture(resolve, reject, options);
            }));

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function takePictureFromGallery() {
    return _ref14.apply(this, arguments);
  };
}();

exports.takePictureFromGallery = takePictureFromGallery;

var takeDocumentFromGallery = /*#__PURE__*/function () {
  var _ref15 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt("return", new _promise["default"](function (resolve, reject) {
              window.navigator.camera.getPicture(resolve, reject, {
                sourceType: window.Camera.PictureSourceType.PHOTOLIBRARY,
                mediaType: window.Camera.MediaType.ALLMEDIA,
                allowEdit: false,
                // marked as unsafe for Android in the docs but seems to work
                destinationType: window.Camera.DestinationType.NATIVE_URI // or FILE_URI

              });
            }));

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function takeDocumentFromGallery() {
    return _ref15.apply(this, arguments);
  };
}();

exports.takeDocumentFromGallery = takeDocumentFromGallery;

var setUsesLightStatusBarBackgroundColor = function setUsesLightStatusBarBackgroundColor(isLight) {
  return getPromise(PLUGIN_GENERAL_TASKS, 'setUsesLightStatusBarBackgroundColor', [{
    isLight: isLight
  }]);
};

exports.setUsesLightStatusBarBackgroundColor = setUsesLightStatusBarBackgroundColor;